import { useEffect, useRef } from "react";

const JITSI_DOMAIN = process.env.REACT_APP_JITSI_DOMAIN || "meet.ffmuc.net";

function loadJitsiScript() {
  if (window.JitsiMeetExternalAPI) return Promise.resolve();
  return new Promise((resolve, reject) => {
    const existing = document.querySelector('script[data-jitsi-external-api="true"]');
    if (existing) {
      existing.addEventListener("load", () => resolve());
      existing.addEventListener("error", () => reject(new Error("Jitsi-Skript konnte nicht geladen werden")));
      return;
    }
    const script = document.createElement("script");
    script.src = `https://${JITSI_DOMAIN}/external_api.js`;
    script.async = true;
    script.dataset.jitsiExternalApi = "true";
    script.onload = () => resolve();
    script.onerror = () => reject(new Error("Jitsi-Skript konnte nicht geladen werden"));
    document.head.appendChild(script);
  });
}

export function JitsiMeeting({ roomName, displayName, onLeave }) {
  const containerRef = useRef(null);
  const apiRef = useRef(null);

  useEffect(() => {
    let cancelled = false;
    loadJitsiScript()
      .then(() => {
        if (cancelled || !containerRef.current || !window.JitsiMeetExternalAPI) return;
        apiRef.current = new window.JitsiMeetExternalAPI(JITSI_DOMAIN, {
          roomName,
          parentNode: containerRef.current,
          width: "100%",
          height: "100%",
          lang: "de",
          userInfo: { displayName },
          configOverwrite: {
            prejoinConfig: { enabled: false },
            startWithAudioMuted: false,
            startWithVideoMuted: false,
            disableThirdPartyRequests: true,
          },
          interfaceConfigOverwrite: {
            TOOLBAR_BUTTONS: [
              "microphone", "camera", "desktop", "fullscreen",
              "hangup", "chat", "settings", "raisehand", "tileview",
            ],
            TOOLBAR_ALWAYS_VISIBLE: true,
          },
          iframeAttributes: {
            allow: "camera; microphone; fullscreen; display-capture; autoplay",
          },
        });
        apiRef.current.addListener("videoConferenceLeft", () => onLeave?.());
      })
      .catch(console.error);
    return () => {
      cancelled = true;
      apiRef.current?.dispose();
      apiRef.current = null;
    };
  }, [roomName, displayName, onLeave]);

  return <div ref={containerRef} className="h-full w-full overflow-hidden rounded-xl" data-testid="jitsi-container" />;
}
